// src/js/modules/copy-link.js
if (!customElements.get("copy-link")) {
  class CopyLink extends HTMLElement {
    constructor() {
      super();
      this.copyButton = this.querySelector("[data-copy-button]");
      this.hasClipboard = navigator.clipboard && navigator.clipboard.writeText;
    }
    connectedCallback() {
      if (!this.hasClipboard) {
        return;
      }
      this.copyButton.classList.remove("hidden");
      this.copyButton.addEventListener("click", this.handleCopy.bind(this));
    }
    async handleCopy() {
      try {
        await navigator.clipboard.writeText(window.location.href);
        const textSpan = this.copyButton.querySelector("[data-copy-text]");
        const originalText = textSpan.textContent;
        textSpan.textContent = "Copied!";
        setTimeout(() => {
          textSpan.textContent = originalText;
        }, 3e3);
      } catch (error) {
        console.error("Error copying to clipboard:", error);
      }
    }
  }
  customElements.define("copy-link", CopyLink);
}
